import React, {Fragment} from 'react';
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import * as yup from "yup";
import {Controller, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup/dist/yup";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import {styled} from '@mui/material/styles';
import FaceIcon from '@mui/icons-material/Face';
import Chip from '@mui/material/Chip';
import EmployeeService from "../../services/employee.service";

const schema = yup.object({
    consumerName: yup.string()
        .required("Consumer name is required!")
        .min(1, "Name is too short!")
        .max(100, "Name is too long.")
}).required();

const ListItem = styled('li')(({theme}) => ({
    margin: theme.spacing(0.5),
}));

const AssignClient = ({emp, reFetch}) => {
    const formState = {consumerName: ""}
    const {handleSubmit, control, reset, formState: {errors}} = useForm({
        defaultValues: formState,
        resolver: yupResolver(schema)
    });
    const onSubmit = async (data) => {
        await EmployeeService.updateClients(emp.id, data);
        reFetch(emp.id);
        reset(formState);
    }
    const handleDelete = async (item) => {
        await EmployeeService.deleteClient(emp.id, item)
        reFetch(emp.id);
    };

    return (
        <Fragment>
            <Paper>
                <Box component="form" noValidate sx={{mt: 1, mb: 2}} onSubmit={handleSubmit(onSubmit)}>
                    <Stack
                        justifyContent="center"
                        alignItems="center"
                        direction={{xs: 'column', sm: 'row'}}
                        spacing={{xs: 1}}
                        sx={{p: 2}}
                    >
                        <FormControl>
                            <Controller
                                name="consumerName"
                                control={control}
                                render={({field}) =>
                                    <TextField
                                        {...field}
                                        label="Enter consumer name"
                                        variant="outlined"
                                        fullWidth={true}
                                        error={!!errors.consumerName}
                                        helperText={errors.consumerName && errors.consumerName.message}
                                    />
                                }
                            />
                        </FormControl>
                        <Button
                            type="submit"
                            variant="contained"
                            sx={{mt: 1}}
                        >
                            Submit
                        </Button>
                    </Stack>
                </Box>
            </Paper>
            <Grid container spacing={{xs: 1, md: 2}} columns={{xs: 4, sm: 8, md: 12}}>
                {emp && emp.clients && emp.clients.map((item, index) => (
                    <Grid item xs={4} sm={8} md={4} key={index}>
                        <Paper sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            flexWrap: 'wrap',
                            listStyle: 'none',
                            p: 0.5,
                            m: 0,
                        }}
                               component={"ul"}>
                            <ListItem key={item}>
                                <Chip label={item} size="medium" variant="outlined" onDelete={() => handleDelete(item)}
                                      icon={<FaceIcon/>}/>
                            </ListItem>
                        </Paper>
                    </Grid>
                ))}
            </Grid>
        </Fragment>
    );
};

export default AssignClient;